<template>
  <div>
    <navigator></navigator>
    <router-view/>
  </div>
</template>

<script>
import navigator from "@/components/navigator";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    navigator
  }
};
</script>

<style>
</style>
